export default __webpack_public_path__ + "static/media/Vectormapsearch.df247f16.svg";